import { t } from "i18next";
import * as React from "react";
import { type MenuTab2Item, MenuTabs2 } from "src/components/MenuTabs2";
import { PageUrl } from "src/routes/PageUrl";

import * as styles from "./ManagementUsersAndRoles.module.less";

type UsersAndRolesTab = "roles" | "users";

const tabs: Record<UsersAndRolesTab, MenuTab2Item> = {
  users: { label: t("Users"), page: PageUrl.managementUsers },
  roles: { label: t("Roles"), page: PageUrl.managementRoles },
};

type PropsManagementUsersAndRoles = {
  tab: UsersAndRolesTab;
  children: React.ReactNode;
};

/**
 * Страница управления пользователями и ролями
 */
export const ManagementUsersAndRoles: React.FC<
  PropsManagementUsersAndRoles
> = ({ tab, children }) => (
  <div className={styles.box}>
    <MenuTabs2 activeTab={tab} tabs={tabs} />
    <div className={styles.content}>{children}</div>
  </div>
);
